import React from "react";

function RedirectToOnboardingIcon() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="48"
			height="48"
			fill="none"
			viewBox="0 0 48 48"
		>
			<circle cx="24" cy="24" r="24" fill="#F1EAFA" />
			<g clipPath="url(#clip0_2317_173457)">
				<path
					fill="#D3BEF1"
					d="M45.925 10.68L37.406 2.16a1.275 1.275 0 00-.43-.075H15.493a3.011 3.011 0 00-3.008 3.008v37.812a3.011 3.011 0 003.008 3.008h27.5A3.011 3.011 0 0046 42.906V11.11c0-.148-.027-.292-.075-.43z"
				/>
				<path
					fill="#722ED1"
					d="M45.925 10.68L37.406 2.16a1.275 1.275 0 00-.43-.075h-7.734v43.828h13.75A3.011 3.011 0 0046 42.906V11.11c0-.148-.027-.292-.075-.43z"
					opacity="0.5"
				/>
				<path
					fill="#3630A2"
					d="M2.755 45.159a2.578 2.578 0 003.646 0l11.47-11.47-3.646-3.646-11.47 11.47a2.578 2.578 0 000 3.646z"
				/>
				<path
					fill="#2E2654"
					d="M2.755 45.159a2.578 2.578 0 003.646 0l11.47-11.47-1.823-1.823L2.755 45.159z"
				/>
				<path
					fill="#D3BEF1"
					d="M45.622 10.198l-7.734-7.735a1.286 1.286 0 00-.482-.302v7.23c0 .711.577 1.289 1.29 1.289h7.229a1.286 1.286 0 00-.303-.482z"
				/>
				<path
					fill="#512194"
					d="M31.82 12.398H18.93a1.29 1.29 0 110-2.578h12.89a1.29 1.29 0 010 2.578zM39.555 38.18H32.68a1.29 1.29 0 010-2.578h6.875a1.29 1.29 0 110 2.578zM39.555 17.555h-18.22a1.29 1.29 0 010-2.578h18.22a1.29 1.29 0 110 2.578zM39.555 22.71h-18.22a1.289 1.289 0 110-2.577h18.22a1.29 1.29 0 010 2.578z"
				/>
				<path
					fill="#512194"
					d="M40.844 21.422a1.29 1.29 0 00-1.29-1.29H29.243v2.579h10.313a1.29 1.29 0 001.289-1.29zM39.555 27.867h-18.22a1.29 1.29 0 010-2.578h18.22a1.29 1.29 0 110 2.578z"
				/>
				<path
					fill="#512194"
					d="M39.555 27.867a1.29 1.29 0 000-2.578H29.242v2.578h10.313zM39.555 33.023h-18.22a1.289 1.289 0 110-2.578h18.22a1.29 1.29 0 010 2.578z"
				/>
				<path
					fill="#512194"
					d="M39.555 33.023a1.29 1.29 0 100-2.578H29.242v2.578h10.313z"
				/>
				<path
					fill="#C1DBFB"
					d="M21.336 36.89c5.695 0 10.312-4.616 10.312-10.312 0-5.695-4.617-10.312-10.312-10.312-5.695 0-10.313 4.617-10.313 10.312 0 5.696 4.617 10.313 10.313 10.313z"
				/>
				<path
					fill="#0074E8"
					d="M28.625 19.29L14.047 33.867a10.28 10.28 0 007.289 3.024c5.686 0 10.313-4.627 10.313-10.313a10.28 10.28 0 00-3.024-7.288z"
					opacity="0.5"
				/>
				<path
					fill="#FF8493"
					d="M23.055 28.727h-3.438a6.42 6.42 0 00-6.351 5.38l3.228 2.006 3.228 1.716h3.228l3.228-1.716 3.228-2.007a6.42 6.42 0 00-6.351-5.38z"
				/>
				<path
					fill="#FF1F3D"
					d="M23.055 28.727h-1.72v9.102h1.615l3.228-1.716 3.228-2.007a6.42 6.42 0 00-6.351-5.38z"
				/>
				<path
					fill="#FFD7AA"
					d="M21.336 30.445a5.162 5.162 0 01-5.156-5.156 5.162 5.162 0 015.156-5.156 5.162 5.162 0 015.156 5.156 5.162 5.162 0 01-5.156 5.156z"
				/>
				<path
					fill="#005EDF"
					d="M21.336 38.18c-6.397 0-11.602-5.205-11.602-11.602s5.205-11.601 11.602-11.601 11.602 5.204 11.602 11.601c0 6.397-5.205 11.602-11.602 11.602zm0-20.625c-4.976 0-9.023 4.048-9.023 9.023 0 4.976 4.047 9.024 9.023 9.024s9.023-4.048 9.023-9.024c0-4.975-4.048-9.023-9.023-9.023z"
				/>
				<path
					fill="#3630A2"
					d="M29.536 18.378l-1.823 1.823a8.996 8.996 0 012.646 6.377c0 4.976-4.048 9.024-9.023 9.024a8.996 8.996 0 01-6.378-2.646l-1.822 1.822c2.1 2.1 5.001 3.402 8.2 3.402 6.397 0 11.602-5.205 11.602-11.602 0-3.198-1.302-6.099-3.402-8.2z"
				/>
				<path
					fill="#FFC58F"
					d="M21.336 20.133v10.312a5.162 5.162 0 005.156-5.156 5.162 5.162 0 00-5.156-5.156z"
				/>
				<path
					fill="#512194"
					d="M33.11 11.11a1.29 1.29 0 00-1.29-1.29h-2.578v2.578h2.578a1.29 1.29 0 001.29-1.289zM40.844 16.266a1.29 1.29 0 00-1.29-1.29H29.243v2.579h10.313a1.29 1.29 0 001.289-1.29z"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2317_173457">
					<path fill="#fff" d="M0 0H44V44H0z" transform="translate(2 2)" />
				</clipPath>
			</defs>
		</svg>
	);
}

export default RedirectToOnboardingIcon;
